import { columnDefsMap } from "./columnDefsMap";
import { ResourceType } from "../../../../../../services/cloudchipr.api";

export const getColumnDefByResourceType = (
  resourceType: ResourceType,
  hiddenColumns: string[] = [],
) => {
  return (
    columnDefsMap.get(resourceType)?.filter((colDef) => {
      const id = colDef.field as string;

      return !hiddenColumns.includes(id);
    }) ?? null
  );
};
